<template>
  <panel>
    <p slot="header">
      Stwórz szablon
    </p>
    <p slot="actions">
      <ui-button type="flat" icon="navigate_before" color="primary" @click="$router.push({name: 'admin.templates.dashboard'})">Wróć do szablonów</ui-button>
    </p>
    <templates-form :item="item"></templates-form>
  </panel>

</template>
<script>
import Templates from './../../services/Templates'

export default {
  data () {
    return {
      item: Templates.getBaseItem()
    }
  },
  mounted () {
  }
}

</script>


// WEBPACK FOOTER //
// Create.vue?3f4ea2d5